import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import styles from './styles.scss';

const LinkButton = forwardRef(
  ({ href, children, variant, className, ...otherProps }, ref) => {
    const classNames = [styles.btn, styles[variant], className];

    return (
      <a ref={ref} href={href} className={classNames.join(' ')} {...otherProps}>
        {children}
      </a>
    );
  }
);

LinkButton.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    'default',
    'primary',
    'primary-outline',
    'secondary',
    'icon',
    'text'
  ]),
  className: PropTypes.string
};

LinkButton.defaultProps = {
  variant: 'default',
  className: null
};

export default LinkButton;
